import { Record } from 'immutable'

const ContentDataTextRecord = Record({
  body: '',
  title: '',
})

export default ContentDataTextRecord
